export default {
    searchModel: 'search-tab',
    searchTabs: [{
        title: 'Posts',
        link: '/search'
    }, {
        title: 'Profile',
        link: '/search/profile'
    }, 
    // {
    //     title: 'Tags',
    //     link: '/search/tags'
    // }
    ],
    searchList: [],
    searchListLimit: 10,
    searchListOffset: 0,
    searchListFetchCompleted: false 
}